<template>
  <div v-if="authenticated" class="Home pt-2">
    <div class="Home__diverse mx-3">
      <diverse-slider data-v-step="1"></diverse-slider>
    </div>

    <div v-if="isReferralPromoActive" class="mx-3 mt-3 mb-4 referral-banner-wrapper" @click="pushToReferralRoute">
      <div class="referral-banner-v2 d-flex align-center elevation-6">
        <!-- Content -->
        <div style="width: 100%" class="referral-content d-flex align-stretch justify-stretch my-auto">
          <!-- Prämie Badge Links -->
          <div class="prize-badge">
            <div class="prize-currency">CHF</div>
            <div class="prize-amount">100</div>
            <div class="prize-perforation"></div>
          </div>

          <!-- Main Text -->
          <!-- Main Text -->
          <div class="flex-grow-1 d-flex flex-column justify-center px-4 py-3">
            <div class="d-flex align-start flex-wrap flex-column" style="column-gap: 10px; row-gap: 2px">
              <span class="extended-tag">VERLÄNGERT</span>
              <h3 class="referral-title mb-0">BRING A <span class="primary--text">FRIEND</span></h3>
            </div>
            <div class="grey--text text--lighten-1 caption font-weight-medium">
              <v-icon x-small color="grey lighten-1">mdi-gift-outline</v-icon>
              Prämie sichern <br />Nur noch im Mai
            </div>
          </div>

          <!-- Arrow -->
          <div class="referral-arrow d-flex align-center justify-center px-3">
            <v-icon color="primary" large>mdi-arrow-right-thick</v-icon>
          </div>
        </div>

        <!-- Layered background -->
        <div class="referral-bg-base"></div>
        <div class="referral-orb referral-orb--1"></div>
        <div class="referral-orb referral-orb--2"></div>
        <div class="referral-shimmer"></div>
        <div class="referral-grid"></div>

        <!-- Bottom Neon Line -->
        <div class="neon-bottom-line"></div>
      </div>
    </div>
    <towel-reservation class="mt-5"></towel-reservation>

    <!-- HYROX SCORE PROMOTION BANNER -->
    <div v-if="isHyroxScorePromoActive" class="mx-3 mt-3 mb-4 hyrox-score-teaser-wrapper" @click="$router.push('/hyrox-score')">
      <div class="hyrox-score-teaser elevation-6">
        <div class="teaser-glow"></div>
        <div class="teaser-content d-flex align-center justify-space-between pa-4">
          <div class="d-flex align-center flex-grow-1 mr-4">
            <div class="custom-hyrox-logo mr-4 spin-on-hover">
              <div class="logo-inner">
                <div class="hyrox-title">HYROX</div>
                <div class="partition-line"></div>
                <div class="score-subtitle">SCORE</div>
              </div>
              <div class="live-dot-container">
                <span class="live-dot"></span>
              </div>
            </div>
            <div class="flex-grow-1">
              <h3 class="text-h6 font-weight-black yellow--text text--darken-2 mb-0 leading-tight italic-font">HYROX SCORE EVENT</h3>

              <div v-if="hyroxScoreStats.myRegistration" class="white--text caption font-weight-bold d-flex align-center mt-1">
                <v-icon x-small color="green" class="mr-1">mdi-check-circle</v-icon>
                Euer Team ist erfolgreich angemeldet! 💥
              </div>

              <div v-else-if="hyroxScoreStats.isClosed" class="white--text caption mt-1">Anmeldung geschlossen (11. Juli)</div>

              <div v-else class="white--text caption d-flex flex-column mt-1">
                <div class="d-flex justify-space-between align-center mb-1">
                  <span>19. Juli 2026 <br />St. Gallen West</span>
                  <span class="font-weight-black yellow--text text--darken-2">
                    {{ Math.max(0, hyroxScoreStats.limit - hyroxScoreStats.activeParticipants) }} Plätze frei!
                  </span>
                </div>
                <v-progress-linear
                  :value="(hyroxScoreStats.activeParticipants / hyroxScoreStats.limit) * 100"
                  color="#fbc02d"
                  height="6"
                  class="rounded-sm mt-1"></v-progress-linear>
              </div>
            </div>
          </div>
          <v-btn icon dark small class="arrow-btn">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <div
          class="neon-stripe"
          :class="{
            'stripe-green': hyroxScoreStats.myRegistration,
            'stripe-yellow': !hyroxScoreStats.myRegistration && hyroxScoreStats.activeParticipants < hyroxScoreStats.limit,
            'stripe-red': !hyroxScoreStats.myRegistration && hyroxScoreStats.activeParticipants >= hyroxScoreStats.limit,
          }"></div>
      </div>
    </div>

    <license-plate-popup ref="licensePopup" :user="user"></license-plate-popup>
    <!--
    <div v-if="showParty" class="mx-3 mt-3 mb-4 party-banner-wrapper" @click="$router.push('/party')">
      <div class="party-banner elevation-4">
        <div class="banner-bg"></div>
        <div class="glitter-overlay"></div>
        
        <div class="banner-content d-flex align-center justify-space-between pa-4">
          <div class="d-flex align-center">
            <div class="icon-circle-party mr-4">
              <v-icon color="white" large>mdi-party-popper</v-icon>
            </div>
            <div>
              <h3 class="text-h6 font-weight-black green--text text--accent-3 mb-0" style="line-height: 1.2">WELL COME FIT PARTY</h3>
              <div class="white--text caption font-weight-bold">Jetzt anmelden & feiern!</div>
            </div>
          </div>
          <v-btn icon dark small>
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <div class="status-stripe-party"></div>
      </div>
    </div>
    -->

    <chat-home-teaser></chat-home-teaser>

    <div class="Home__membership mx-3 mt-3 mb-3">
      <!-- Switch for Employees -->
      <div
        v-if="
          userService.hasRight('tt_employeeManage') &&
          !isStudioAccount &&
          !(
            userService.getEmail() === 'sebs@wellcomefit.ch' ||
            userService.getEmail() === 'dominic.ammann.ch@gmail.com' ||
            userService.getEmail() === 'tk@wellcomefit.ch'
          )
        "
        class="text-right mb-1">
        <v-btn x-small text color="grey" @click="showEmployeeCard = !showEmployeeCard">
          {{ showEmployeeCard ? "Zum Abo" : "Zur Zeiterfassung" }}
          <v-icon right x-small>{{ showEmployeeCard ? "mdi-card-account-details" : "mdi-clock" }}</v-icon>
        </v-btn>
      </div>

      <mini-stats-dashboard
        v-if="
          userService.getEmail() === 'sebs@wellcomefit.ch' ||
          userService.getEmail() === 'dominic.ammann.ch@gmail.com' ||
          userService.getEmail() === 'tk@wellcomefit.ch'
        "></mini-stats-dashboard>

      <employee-card v-else-if="userService.hasRight('tt_employeeManage') && showEmployeeCard && !isStudioAccount" :user="user"></employee-card>

      <active-contract-card
        v-if="!userService.hasRight('tt_employeeManage') || !showEmployeeCard"
        :user="user"
        @contracts-loaded="hasActiveContracts = true"
        @no-contracts="hasActiveContracts = false"
        @upgrade="openContractUpgrade"
        @quick-upgrade="handleQuickUpgrade"
        @timestop="openTimestop"
        @healthcare="openHealthcare"></active-contract-card>

      <div v-if="hasActiveContracts === false" class="mt-3">
        <membercard
          v-if="hasValidMembercard"
          :membercard="user.membercard"
          :firstName="user.vorname"
          :lastName="user.nachname"
          :email="user.email"
          @hideTraining="hideMyTraining = true"></membercard>

        <v-card
          v-else
          class="rounded-xl pa-5 d-flex flex-column align-center justify-center text-center orange darken-3 white--text"
          elevation="5"
          @click="showNoContractInfo = true"
          v-ripple>
          <v-icon size="40" color="white" class="mb-2">mdi-help-circle-outline</v-icon>
          <div class="font-weight-bold text-h6">Keine Mitgliedschaft?</div>
          <div class="caption opacity-90 mb-3">Wir konnten kein aktives Abo finden.</div>
          <v-btn rounded small color="white" class="orange--text text--darken-3 font-weight-bold px-4"> Ich habe aber ein Abo! </v-btn>
        </v-card>
      </div>
    </div>

    <div>
      <payment-home @foundOpenPayments="openPayments = true"></payment-home>
    </div>

    <div v-if="!alibeyStudio && !hideMyTraining" class="Home__training mx-3">
      <my-training data-v-step="0"></my-training>
    </div>

    <router-view></router-view>

    <div class="Home__groupFitness pb-5 mb-16 mx-3 mt-3">
      <training-zone data-v-step="2"></training-zone>
    </div>

    <alibey-popup></alibey-popup>
    <black-week-teaser></black-week-teaser>

    <upgrade-contract
      :useCustomer="true"
      :dialog="showContractDialog"
      :preloaded-possibilities="preloadedPossibilities"
      :initial-selected-package="initialSelectedPackage"
      @hide="closeContractDialog"
      @created="upgradeCreated()"></upgrade-contract>

    <v-dialog style="z-index: 9999" v-model="timestopActive" persistent fullscreen transition="dialog-bottom-transition">
      <user-time-stop
        @reFetchTimestops="getAllTimestops()"
        :user="user"
        :userTimestops="userTimestops"
        @close-view="timestopActive = false"></user-time-stop>
    </v-dialog>

    <v-dialog style="z-index: 9999" v-model="healthcareActive" persistent fullscreen transition="dialog-bottom-transition">
      <user-healthcare @close-view="healthcareActive = false"></user-healthcare>
    </v-dialog>

    <v-dialog v-model="showNoContractInfo" max-width="420" content-class="glass-dialog-wrapper">
      <v-card class="glass-dialog-card text-center pa-5">
        <div class="glow-effect"></div>

        <v-card-title class="justify-center flex-column pt-4 pb-2 relative z-index-2">
          <div class="icon-ring mb-5">
            <v-icon size="42" color="#FF9800">mdi-card-account-details-outline</v-icon>
          </div>
          <span class="text-h5 font-weight-black white--text text-shadow leading-tight"> Wo ist dein Abo? </span>
        </v-card-title>

        <v-card-text class="text-body-1 grey--text text--lighten-2 px-2 relative z-index-2">
          <p class="mb-5" style="font-size: 0.95rem">
            Du bist Mitglied, aber dein Abo wird hier nicht angezeigt? Keine Sorge, das ist meist nur eine Kleinigkeit.
          </p>

          <div class="info-box pa-4 rounded-xl mb-5 text-left">
            <div class="d-flex align-start">
              <v-icon color="#FF9800" class="mr-3 mt-1">mdi-alert-circle-outline</v-icon>
              <div class="caption white--text" style="line-height: 1.5; font-size: 0.85rem !important">
                <strong class="d-block mb-1 text-uppercase orange--text text--accent-2">Der Grund</strong>
                Unsere App und die Mitgliederverwaltung sind getrennt. Wenn deine E-Mail-Adresse hier anders ist als im Vertrag, finden wir dich nicht
                automatisch.
              </div>
            </div>
          </div>

          <p class="mb-1 white--text font-weight-bold">Die Lösung ist ganz einfach:</p>
          <p class="caption grey--text mb-0">
            Melde dich kurz beim <strong>Trainer-Team an der Theke</strong>. Wir gleichen die E-Mail-Adressen an und schon taucht dein Abo hier auf!
            🚀
          </p>
        </v-card-text>

        <v-card-actions class="justify-center pb-4 relative z-index-2">
          <v-btn rounded large block color="white" class="black--text font-weight-bold elevation-10 py-6" @click="showNoContractInfo = false">
            Alles klar, verstanden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 
      <div>
        <v-card
        class="mx-4 mt-4 rounded-xl d-flex align-center pa-3 elevation-10"
        style="background: linear-gradient(45deg, #000, #1a4d23)"
        @click="showWrapped = true">
        <v-avatar color="white" size="48" class="mr-3">
          <span class="black--text font-weight-black">2025</span>
        </v-avatar>
        <div>
          <div class="white--text font-weight-bold">Dein Jahr 2025</div>
          <div class="green--text text--accent-3 caption">Jetzt ansehen &rarr;</div>
        </div>
      </v-card>
    </div>
    -->
  </div>
</template>

<script>
import api from "../api"
import { mapState, mapActions } from "vuex"
import userService from "../services/userService"

// Components Imports
import myTraining from "../components/training/myTraining_new.vue"
import diverseSlider from "../components/home/diverseSlider_new.vue"
import alibeyPopup from "@/views/aliBey/alibeyPopup.vue"
import PaymentHome from "./dashboard/payment/PaymentHome.vue"
import googleFeedbackDialog from "@/components/home/googleFeedbackDialog.vue"
import TowelReservation from "@/components/TowelReservation.vue"
import BlackWeekTeaser from "@/views/einmalig/BlackWeekTeaser.vue"
import TrainingZone from "@/components/home/TrainingZone.vue"

// Neue Karten Components
import membercard from "@/components/home/membercard_new.vue"
import ActiveContractCard from "@/components/home/ActiveContractCard.vue"
import EmployeeCard from "@/components/home/EmployeeCard.vue"

// Dialog Components
import UserTimeStop from "@/views/user/views/UserTimestop.vue"
import UserHealthcare from "@/views/user/views/UserHealthcare.vue"
import UpgradeContract from "@/views/dashboard/contract/components/upgradeContract_sebredesign.vue"

import HyroxReservation from "@/components/HyroxReservation.vue"
import ChatHomeTeaser from "@/components/home/chatHomeTeaser.vue"

import MiniStatsDashboard from "@/components/home/miniStatsDashboard.vue"
import LicensePlatePopup from "@/components/home/licensePlatePopup.vue"
export default {
  name: "Home",
  components: {
    LicensePlatePopup,
    googleFeedbackDialog,
    diverseSlider,
    TrainingZone,
    TowelReservation,
    alibeyPopup,
    myTraining,
    BlackWeekTeaser,
    PaymentHome,
    membercard,
    ActiveContractCard,
    EmployeeCard,
    UserTimeStop,
    UserHealthcare,
    UpgradeContract,
    HyroxReservation,
    ChatHomeTeaser,
    MiniStatsDashboard,
  },
  data() {
    return {
      hyroxAvailability: { block1: null, block2: null },
      hyroxScoreStats: {
        activeParticipants: 0,
        limit: 84,
        isClosed: false,
        myRegistration: null,
      },
      showHyroxDialog: false,
      showEmployeeCard: true,
      showNoContractInfo: false,
      userService,
      hideMyTraining: false,
      openPayments: false,
      //showParty: false,

      // Contracts Data
      hasActiveContracts: null,

      // Dialog Controls
      showContractDialog: false,
      timestopActive: false,
      healthcareActive: false,
      showNoContractInfo: false,

      preloadedPossibilities: null,
      initialSelectedPackage: null,
    }
  },
  watch: {
    user(newUser) {
      if (newUser?.consent1 && !this.navigationVisible) {
        this.toggleNavigationBarVisibility()
      }
    },
  },

  async created() {
    this.setSelectedNavigation("home")

    if (localStorage.getItem("token")) {
      if (!localStorage.getItem("pushToken") && window.flutter_inappwebview) {
        if (!localStorage.getItem("initPushCooldown")) {
          this.$emit("showPushPopUp")
        }
      }
      this.$emit("checkPopup")
      this.$emit("checkVersion")
      this.$emit("fetchNotifications")
      this.setNavigationBarText(null)
      this.setNewBottomNavigationUsage(null)
      if (this.$moment().isBefore(this.$moment("2026-05-01"))) {
        this.fetchHyroxAvailability()
      }
      if (this.isHyroxScorePromoActive) {
        this.fetchHyroxScoreAvailability()
      }
      // NACH dem Laden der grundlegenden Daten das Popup prüfen:
      setTimeout(() => {
        if (this.$refs.licensePopup && this.user && this.user.studio && this.user.studio.parkingAvailable) {
          this.$refs.licensePopup.checkAndShow()
        }
      }, 2000) // Leichter Delay, damit es nicht direkt beim Mounten aggressiv aufploppt
      /*
      let party = await api.fetchSignupAvailabilityParty()
      if (party.isEmployee && party.visible) {
        this.showParty = true
      }*/
    }

    // Lade Vertragsdaten
    this.getAllTimestops()
  },

  computed: {
    ...mapState("navigationStoreNotPersisted", ["navigationVisible"]),
    ...mapState("studioStore", ["selectedStudio"]),
    ...mapState("userStore", ["user"]),
    isHyroxPftPromoActive() {
      // Datum-Check bleibt, aber wir zeigen auch wenn ausgebucht
      return this.$moment().isBefore(this.$moment("2026-09-01"))
    },
    isHyroxScorePromoActive() {
      return this.$moment().isBefore(this.$moment("2026-07-19T09:00:00"))
    },
    isHyroxSoldOut() {
      if (this.hyroxAvailability.block1 === null) return false
      return this.hyroxSpotsLeft <= 0
    },
    hyroxSpotsLeft() {
      const b1 = this.hyroxAvailability.block1 || 0
      const b2 = this.hyroxAvailability.block2 || 0
      return b1 + b2
    },
    isReferralPromoActive() {
      const now = this.$moment()

      return now.month() === 4 && now.year() === 2026
    },
    authenticated() {
      return !!localStorage.getItem("token")
    },
    alibeyStudio() {
      return this.user && this.user.studio_id === "alibey"
    },
    isStudioAccount() {
      return this.user?.email === this.user?.studio?.email
    },
    buelachStudio() {
      return this.user && this.user.studio_id === "buelach"
    },

    // --- NEU: Prüft ob Membercard gültig ist (Zeit + Status) ---
    hasValidMembercard() {
      const mc = this.user?.membercard
      // 1. Grundlegende Checks
      if (!mc || !mc.isActive || !mc.endDate) return false

      // 2. Datums-Check: Ist endDate heute oder in Zukunft?
      // Wir nutzen $moment (Globale Vue Instanz)
      // 'day' Granularität sorgt dafür, dass die Karte bis zum Ende des Tages gültig bleibt
      return this.$moment().isSameOrBefore(this.$moment(mc.endDate), "day")
    },
  },

  methods: {
    ...mapActions("navigationStoreNotPersisted", ["setNavigationBarText", "setNewBottomNavigationUsage", "toggleNavigationBarVisibility"]),
    ...mapActions("navigationStore", ["setSelectedNavigation"]),
    async fetchHyroxAvailability() {
      try {
        const data = await api.fetchHyroxPFTEventAvailability()
        this.hyroxAvailability = data
      } catch (e) {
        console.error("Hyrox availability konnte nicht geladen werden", e)
      }
    },
    async fetchHyroxScoreAvailability() {
      try {
        const data = await api.hyroxScore.fetchAvailability()
        this.hyroxScoreStats = data
      } catch (e) {
        console.error("Hyrox score availability konnte nicht geladen werden", e)
      }
    },
    openHyroxRegistration() {
      const url = "https://wellcomefit.ch/events/hyrox"

      window.open(url, "_blank")

      this.showHyroxDialog = false
    },
    pushToReferralRoute() {
      this.$router.push("/referral")
    },
    upgradeCeated() {
      this.$toast.success("Dein Antrag wurde erfolgreich erstellt!")
    },
    openContractUpgrade(payload) {
      // Wenn die Karte uns schon Daten mitschickt, nutzen wir sie!
      if (payload && payload.possibilities) {
        this.preloadedPossibilities = payload.possibilities
      } else {
        this.preloadedPossibilities = null
      }
      this.initialSelectedPackage = null // Kein spezifisches Paket gewählt
      this.showContractDialog = true
    },

    // 2. Klick auf "Dazu buchen" Chip (Spezifisch)
    handleQuickUpgrade(payload) {
      // Payload enthält: { package, possibilities }
      this.preloadedPossibilities = payload.possibilities
      this.initialSelectedPackage = payload.package
      this.showContractDialog = true
    },

    closeContractDialog() {
      this.showContractDialog = false
      // Kurze Verzögerung beim Reset, damit die Animation nicht ruckelt
      setTimeout(() => {
        this.preloadedPossibilities = null
        this.initialSelectedPackage = null
      }, 300)
    },
    async getAllTimestops() {
      try {
        this.userTimestops = await api.fetchAllTimestopsForUserEmail()
      } catch (e) {}
    },
    openContractUpgrade() {
      this.showContractDialog = true
    },
    openTimestop() {
      this.timestopActive = true
    },
    openHealthcare() {
      this.healthcareActive = true
    },

    // Helper für Contract Berechnung
    daysInTimeSpan(timeSpan) {
      const start = this.$moment(timeSpan.TimeSpan.Start, "YYYY-MM-DD")
      const end = this.$moment(timeSpan.TimeSpan.End, "YYYY-MM-DD")
      return end.diff(start, "days") + 1
    },
    bonusCalculatedFromMultipleTimespans(allTimeSpans, timeSpanDays) {
      const totalDays = allTimeSpans.reduce((total, timeSpan) => total + this.daysInTimeSpan(timeSpan), 0)
      return (
        Number(totalDays) === Number(timeSpanDays) || Number(totalDays) - 1 === Number(timeSpanDays) || Number(totalDays) + 1 === Number(timeSpanDays)
      )
    },
    // -----------------------------------

    pushToReferralRoute() {
      this.$router.push("/referral")
    },
  },
}
</script>

<style lang="scss" scoped>
.extended-tag {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: var(--v-primary-base, #4caf50);
  text-transform: uppercase;
  white-space: nowrap;
  text-shadow: 0 0 8px rgba(var(--v-primary-base-rgb, 76, 175, 80), 0.5);

  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--v-primary-base, #4caf50);
    margin-right: 6px;
    box-shadow: 0 0 6px var(--v-primary-base, #4caf50), 0 0 12px rgba(var(--v-primary-base-rgb, 76, 175, 80), 0.6);
    animation: dotBlink 1.5s ease-in-out infinite;
  }
}

@keyframes dotBlink {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.85);
  }
}
.extended-pill {
  display: inline-flex;
  align-items: center;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 1.2px;
  padding: 3px 8px;
  border-radius: 10px;
  background: rgba(var(--v-primary-base-rgb, 76, 175, 80), 0.15);
  color: var(--v-primary-base, #4caf50);
  border: 1px solid rgba(var(--v-primary-base-rgb, 76, 175, 80), 0.4);
  text-transform: uppercase;
  white-space: nowrap;
  position: relative;
  box-shadow: 0 0 8px rgba(var(--v-primary-base-rgb, 76, 175, 80), 0.3);
  animation: pillPulse 2.5s ease-in-out infinite;

  // kleiner Punkt davor (wie ein Live-Indicator)
  &::before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--v-primary-base, #4caf50);
    margin-right: 5px;
    box-shadow: 0 0 4px var(--v-primary-base, #4caf50);
    animation: dotBlink 1.5s ease-in-out infinite;
  }
}

@keyframes pillPulse {
  0%,
  100% {
    box-shadow: 0 0 8px rgba(var(--v-primary-base-rgb, 76, 175, 80), 0.3);
  }
  50% {
    box-shadow: 0 0 14px rgba(var(--v-primary-base-rgb, 76, 175, 80), 0.6);
  }
}

@keyframes dotBlink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}
.Home {
  max-width: 800px;
  margin: 0 auto;
}

/* --- GLASS DIALOG STYLES --- */

/* Wrapper unsichtbar machen, damit der Schatten nicht eckig ist */
::v-deep .glass-dialog-wrapper {
  box-shadow: none !important;
  overflow: visible !important;
}

.glass-dialog-card {
  background: rgba(20, 20, 20, 0.85) !important; /* Dunkle Basis */
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px); /* Für Safari */
  border: 1px solid rgba(255, 255, 255, 0.1); /* Subtiler weißer Rand */
  border-radius: 28px !important;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5) !important;
}

/* Orangefarbener Schein im Hintergrund */
.glow-effect {
  position: absolute;
  top: -20%;
  left: 50%;
  transform: translateX(-50%);
  width: 150%;
  height: 60%;
  background: radial-gradient(circle, rgba(255, 152, 0, 0.25) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
  filter: blur(30px);
}

.icon-ring {
  width: 85px;
  height: 85px;
  border-radius: 50%;
  background: rgba(255, 152, 0, 0.1);
  border: 1px solid rgba(255, 152, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 30px rgba(255, 152, 0, 0.15);
  margin: 0 auto;
}

.info-box {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

/* Utils */
.z-index-2 {
  position: relative;
  z-index: 2;
}

.text-shadow {
  text-shadow: 0 4px 10px rgba(0, 0, 0, 0.8);
}

.leading-tight {
  line-height: 1.1;
}
.party-banner-wrapper {
  max-width: 800px;
  // Zentrieren falls nötig, aber mx-3 regelt das meiste
  margin-left: auto;
  margin-right: auto;
}

.party-banner {
  position: relative;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  min-height: 80px;

  &:active {
    transform: scale(0.98);
  }

  // Hover Effekt für Desktop
  &:hover {
    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3) !important; // Grüner Schein
  }
}

.banner-bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // Dunkler Verlauf wie bei Hyrox
  background: linear-gradient(135deg, #1a1a1a 0%, #051405 100%);
  z-index: 1;
}

// Der subtile Glitzer Effekt
.glitter-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  opacity: 0.15; // Sehr dezent
  // Ein Muster aus winzigen Punkten
  background-image: radial-gradient(white 1px, transparent 1px), radial-gradient(rgba(76, 175, 80, 0.8) 1px, transparent 1px);
  background-size: 30px 30px;
  background-position: 0 0, 15px 15px;
}

.banner-content {
  position: relative;
  z-index: 2; // Über dem Hintergrund und Glitzer
}

.icon-circle-party {
  width: 48px;
  height: 48px;
  // Sattes Grün
  background: linear-gradient(135deg, #43a047 0%, #2e7d32 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 15px rgba(67, 160, 71, 0.4); // Grüner Glow

  // Kleiner Glanz auf dem Icon-Kreis
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.status-stripe-party {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: #00e676; // Helles Neongrün für den Streifen unten
  z-index: 2;
  box-shadow: 0 -1px 8px rgba(0, 230, 118, 0.5);
}
/* --- REFERRAL BANNER V2 (APRIL) --- */

.referral-banner-wrapper {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.referral-banner-v2 {
  position: relative;
  background: #000;
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;
  min-height: 100px;

  &:active {
    transform: scale(0.98);
  }
  &:hover .referral-arrow {
    transform: translateX(4px);
  }
}

/* Basis-Verlauf: tiefes Schwarz mit grünem Schimmer rechts */
.referral-bg-base {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 85% 50%, #0a2818 0%, #000 65%);
  z-index: -1;
}

/* Ganz feines Raster für Tech-Look */
.referral-grid {
  position: absolute;
  inset: 0;
  z-index: 2;
  background-image: linear-gradient(rgba(0, 230, 118, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 230, 118, 0.04) 1px, transparent 1px);
  background-size: 32px 32px;
  mask-image: linear-gradient(90deg, transparent 0%, #000 30%, #000 70%, transparent 100%);
  -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 30%, #000 70%, transparent 100%);
  pointer-events: none;
}

/* Zwei weiche Glow-Orbs die langsam pulsieren */
.referral-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(35px);
  z-index: 2;
  pointer-events: none;
}

.referral-orb--1 {
  width: 240px;
  height: 240px;
  top: -70px;
  right: 15%;
  background: radial-gradient(circle, rgba(0, 230, 118, 0.65) 0%, transparent 70%);
  animation: orb-float-1 5s ease-in-out infinite;
}

.referral-orb--2 {
  width: 180px;
  height: 180px;
  bottom: -60px;
  right: 0%;
  background: radial-gradient(circle, rgba(0, 200, 100, 0.5) 0%, transparent 70%);
  animation: orb-float-2 6s ease-in-out infinite;
}

@keyframes orb-float-1 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.9;
  }
  50% {
    transform: translate(-40px, 15px) scale(1.35);
    opacity: 1;
  }
}

@keyframes orb-float-2 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.7;
  }
  50% {
    transform: translate(25px, -20px) scale(1.3);
    opacity: 1;
  }
}

/* Diagonaler Shimmer-Sweep – das Highlight */
.referral-shimmer {
  position: absolute;
  inset: 0;
  z-index: 3;
  background: linear-gradient(
    115deg,
    transparent 25%,
    rgba(0, 230, 118, 0.18) 42%,
    rgba(255, 255, 255, 0.28) 50%,
    rgba(0, 230, 119, 0.082) 58%,
    transparent 75%
  );
  background-size: 250% 100%;
  background-repeat: no-repeat;
  animation: shimmer-sweep 2.8s ease-in-out infinite;
  pointer-events: none;
}

@keyframes shimmer-sweep {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

/* Prämie Badge mit Coupon/Ticket Look */
.prize-badge {
  background: linear-gradient(180deg, var(--v-primary-base) 0%, #00b248 100%);
  color: white;
  min-width: 92px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 8px;
}

.prize-currency {
  font-size: 0.7rem;
  font-weight: 900;
  letter-spacing: 2px;
  opacity: 0.85;
  margin-bottom: -2px;
}

.prize-amount {
  font-size: 2.4rem;
  font-weight: 900;
  line-height: 1;
  letter-spacing: -2px;
  font-style: italic;
}

/* Perforierte Kante rechts vom Badge (Coupon-Look) */
.prize-perforation {
  position: absolute;
  top: 0;
  right: -1px;
  bottom: 0;
  width: 6px;
  background-image: radial-gradient(circle at 3px 6px, #000 2.5px, transparent 3px);
  background-size: 6px 12px;
  background-repeat: repeat-y;
}

/* Titel gross, italic */
.referral-title {
  font-size: 1.5rem;
  font-weight: 900;
  font-style: italic;
  color: #fff;
  line-height: 1;
  letter-spacing: -0.5px;
  text-transform: uppercase;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);
}

/* Langsam rotierender Stern */
.spin-slow {
  animation: spin-slow 4s linear infinite;
}
@keyframes spin-slow {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.referral-arrow {
  transition: transform 0.25s ease;
}

/* --- HYROX SCORE TEASER CARD --- */
.hyrox-score-teaser-wrapper {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.hyrox-score-teaser {
  position: relative;
  background: #121214;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  min-height: 84px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(251, 192, 45, 0.15) !important;
    border-color: rgba(251, 192, 45, 0.2);

    .spin-on-hover {
      transform: rotate(5deg) scale(1.05);
    }
    .arrow-btn {
      transform: translateX(3px);
    }
  }

  &:active {
    transform: scale(0.98);
  }
}

.teaser-glow {
  position: absolute;
  top: -50px;
  right: -50px;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle, rgba(251, 192, 45, 0.08) 0%, transparent 70%);
  filter: blur(25px);
  z-index: 1;
  pointer-events: none;
}

.teaser-content {
  position: relative;
  z-index: 2;
}

.spin-on-hover {
  transition: transform 0.2s ease;
}

.italic-font {
  font-style: italic;
  letter-spacing: -0.5px;
}

.neon-stripe {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  z-index: 2;
}

.stripe-yellow {
  background: #fbc02d;
  box-shadow: 0 -1px 8px rgba(251, 192, 45, 0.5);
}

.stripe-green {
  background: #00e676;
  box-shadow: 0 -1px 8px rgba(0, 230, 118, 0.5);
}

.stripe-red {
  background: #ff1744;
  box-shadow: 0 -1px 8px rgba(255, 23, 68, 0.5);
}

.arrow-btn {
  transition: transform 0.2s ease;
}

/* Custom HYROX Score Logo Badge */
.custom-hyrox-logo {
  position: relative;
  width: 62px;
  height: 62px;
  background: linear-gradient(135deg, #0a0a0c 0%, #16161a 100%);
  border: 1px solid rgba(251, 192, 45, 0.4);
  box-shadow: 0 0 20px rgba(251, 192, 45, 0.25), inset 0 0 8px rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: skewX(-8deg);
  flex-shrink: 0;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);

  &::before {
    content: "";
    position: absolute;
    inset: -1px;
    background: linear-gradient(135deg, #fbc02d, #00e676);
    border-radius: 12px;
    z-index: -1;
    opacity: 0.3;
    transition: opacity 0.3s ease;
  }

  &:hover::before {
    opacity: 0.8;
  }

  .logo-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transform: skewX(8deg); /* Korrigiert den Skew-Effekt fuer Text */
  }

  .hyrox-title {
    color: #ffffff;
    font-family: "Impact", "Arial Black", sans-serif;
    font-size: 1.05rem;
    font-weight: 1000;
    line-height: 0.9;
    letter-spacing: 0.5px;
    font-style: italic;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
  }

  .partition-line {
    width: 32px;
    height: 2px;
    background: linear-gradient(90deg, #fbc02d 0%, #00e676 100%);
    margin: 3px 0;
    border-radius: 1px;
  }

  .score-subtitle {
    color: #fbc02d;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 0.55rem;
    font-weight: 900;
    letter-spacing: 1.5px;
    line-height: 1;
    text-transform: uppercase;
    text-shadow: 0 0 5px rgba(251, 192, 45, 0.4);
  }

  .live-dot-container {
    position: absolute;
    top: 4px;
    right: 4px;
    transform: skewX(8deg);
  }

  .live-dot {
    display: block;
    width: 5px;
    height: 5px;
    background-color: #00e676;
    border-radius: 50%;
    box-shadow: 0 0 6px #00e676;
    animation: livePulse 1.5s infinite ease-in-out;
  }
}

@keyframes livePulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
    box-shadow: 0 0 4px #00e676;
  }
  50% {
    transform: scale(1.3);
    opacity: 0.4;
    box-shadow: 0 0 10px #00e676;
  }
}
</style>
